import { PiniaPlugin } from 'pinia';

import { PiniaStoreId } from '@/constants/pinia';
import { USER_SETTINGS_BY_PAGE_STORAGE_KEY, USER_SETTINGS_BY_USER_STORAGE_KEY } from '@/constants/storage';

export const piniaLocalStoragePlugin: PiniaPlugin = (context) => {
  context.store.$subscribe((mutation, state) => {
    if (mutation.storeId === PiniaStoreId.User) {
      localStorage.setItem(USER_SETTINGS_BY_PAGE_STORAGE_KEY, JSON.stringify(state.user.settings));
      localStorage.setItem(USER_SETTINGS_BY_USER_STORAGE_KEY, JSON.stringify(state.user.settingsByUser));
    }
  });
};
